import { AMAZE_TUTORIAL, VIDEO_TITLE } from "./constants";
import DemoVideo from "./DemoVideo";
import styles from "./ToggleVideo.module.scss";

interface IProps {
    handleVideoToggle: () => void;
}

const ToggleVideo = ({ handleVideoToggle }: IProps) => {
    const VideoBackground = () => {
        return <div className={styles.videoBackground} onClick={handleVideoToggle}></div>;
    };

    return (
        <div className={styles.toggleVideo}>
            <VideoBackground />
            <DemoVideo handleVideoToggle={handleVideoToggle} src_url={AMAZE_TUTORIAL} video_title={VIDEO_TITLE} />
        </div>
    );
};

export default ToggleVideo;
